module.exports = __webpack_public_path__ + "img/117.6b045fbd.png";